<template>
	<div class="home">
		
		<template v-if="ready">
			<transition name="logo" appear>
				<div v-show="logo_visible" class="logo">
					<span class="nb">17</span>
					<span class="fighters">fighters</span>
				</div>
			</transition>

			<transition name="button" appear>
				<div v-show="logo_visible" class="button" @click="play()">PLAY</div>
			</transition>
		</template>

		<transition name="start" appear>
			<div v-if="!ready" class="tap-to-start" v-hammer:tap="() => go()">
				<div class="text">Tap to start</div>
			</div>
		</transition>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sounds from '@/js/sounds'

export default {
	name: 'home',
	data() {
		return {
			ready: false,
			logo_visible: false
		}
	},
	computed: {
		...mapGetters([ 'game' ])
	},
	methods: {
		play() {
			Sounds.play('button')
			this.$store.commit('EDIT_APP_STATE', { screen: 'game' })
		},
		go() {
			this.ready = true
			setTimeout(() => {
				this.logo_visible = true
				setTimeout(() => {
					Sounds.play('sword')
				}, 600)
			}, 100)
		}
	},
	mounted() {
		if (this.game.status !== 'starting') this.go()
	}
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/variables'

.home
	height 100%
	flex center center
	flex-direction column
	.logo
		margin 0 0 80px 0
		font-size 6.4rem
		text-transform uppercase
		text-align center
		font-weight 700
		flex center center
		transition 0.5s easeOutQuart
		&.logo-enter
			.nb
				transform scale(2)
				opacity 0
			.fighters
				transform scale(1) translate(-32px, -16px)
				opacity 0
			&:after
				transform rotate(-10deg) scale(1) translate(-500%, 0)
		.nb
			display inline-block
			transition 0.25s easeOutQuart
			margin 0 16px 0 0
			font-size 14rem
			line-height 100px
			// text-shadow 2px 2px #000
		.fighters
			transform translateY(-19px)
			transition 0.25s easeOutQuart
			transition-delay 0.2s
			display inline-block
			font-size 6.4rem
			letter-spacing 2px
			// text-shadow 2px 2px #000
		&:after
			content ''
			position absolute
			left -20px
			right -20px
			top 34%
			height 6px
			background-color dark
			transform rotate(-10deg)
			transition 0.2s easeOutQuart
			transition-delay 0.6s
			// box-shadow 2px 2px #000
	.button
		height 64px
		width 200px
		background-color light
		color dark
		padding-top 2px
		flex center center
		font-weight 700
		cursor pointer
		animation button 1s linear infinite
		&.button-enter-active
			transition 0.25s easeOutQuart
			transition-delay 0.7s
		&.button-enter
			transform translateY(-24px) scale(1.2)
			opacity 0
		&:hover
			animation none
			background-color darken(light, 10%)
		&:active
			animation none
			background-color darken(light, 10%)
			transform translateY(2px)

	.tap-to-start
		absolute 0
		background-color dark
		flex center center
		transition opacity 0.1s easeOutQuart
		cursor pointer
		&.start-leave-to
			opacity 0
		.text
			font-size 2.4rem
			opacity 0.5
			animation button 1s linear infinite

@keyframes button
	0%, 20%, 100%
		transform none
	10%
		transform scale(1.05)


</style>
